import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const AnonymousApi = {
    getStatus: (webinarId: string, authorizationCode?: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['anonymous', 'get', webinarId, authorizationCode || ''], (api) => api.anonymous.get({ webinarId, authorizationCode }), options),
    joinLiveWebinar: (options?: BaseApiMutationOptions<ApiClient['anonymous']['joinLiveWebinar']>) =>
        apiMutationOptions((api) => api.anonymous.joinLiveWebinar, options),
    joinOnDemandWebinar: (options?: BaseApiMutationOptions<ApiClient['anonymous']['joinOnDemandWebinar']>) =>
        apiMutationOptions((api) => api.anonymous.joinOnDemandWebinar, options)
};
